export const THEME_PREVIEWER_NAMESPACE = 'Theme Previewer';
export const EVENTS = {
  PRESET_APPLIED: 'Preset Applied',
  PUBLISH_SETTINGS: 'Publish Settings',
  INTERACTION: 'Interaction'
};